var $c7665739f8770db9$exports = {};
$c7665739f8770db9$exports = {
    "pending": `Ausstehend`
};


export {$c7665739f8770db9$exports as default};
//# sourceMappingURL=de-DE.mjs.map
